import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {FuseMediaWatcherService} from '@fuse/services/media-watcher';
import {FuseNavigationService, FuseVerticalNavigationComponent} from '@fuse/components/navigation';
import {Navigation} from 'app/core/navigation/navigation.types';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {NavigationBuilderService} from "../../../shared/services/navigation-builder.service";
import {SharedService} from "../../../shared/services/shared.service";
import {environment} from "../../../../environments/environment";
import {AdminService} from "../../../modules/admin/admin.service";
import {ApiService} from "../../../shared/services/api.service";
import {NavigationContentIDs, Navigations} from "../../../shared/enums/navigations.enum";

@Component({
    selector: 'compact-layout',
    templateUrl: './compact.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CompactLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    Navigations = Navigations;
    NavigationContentIDs = NavigationContentIDs;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        public router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _apiService: ApiService,
        public navigationBuilderService: NavigationBuilderService,
        public sharedService: SharedService,
        public adminService: AdminService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    /**
     * Checks the url path and sets the initial sub-navigation which should be loaded an app init.
     */
    setInitialSubNavigation(): NavigationContentIDs {
        switch (true) {
            case window.location.pathname.includes('/shares'):
                return NavigationContentIDs.shares;
            case window.location.pathname.includes('/embeds'):
                return NavigationContentIDs.embeds;
            default:
                return NavigationContentIDs.smartvus;
        }
    }

    /**
     * Redirects to /smartvus route in the current workspace.
     */
    redirectToWorkspaceRoot() {
        this.navigationBuilderService.navigateToRouteInWorkspace('/smartvus');
        this.navigationBuilderService.swapNavigationData(Navigations.subNavigation, NavigationContentIDs.smartvus, 'smartvus');
    }

    protected readonly environment = environment;
}
